module.exports = __webpack_public_path__ + "crm_static/img/429@2x.789498be.png";